module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./LDOrderView.js"));
	}, "SpecialView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialView!./src/pages/Shop/Home/LdOrder/LDOrderView.js
// module id = 1832
// module chunks = 367